<div>
  <div class="text-xs mb-10 space-y-2">
    <p>Nessa zona será possível transferir todas as ocorrências criadas por essa conta para um outro
      moderador/administrador.</p>
    <p> Por razões de seguranças precisamos garantir que o utilizador tem certeza dessa operação.</p>
  </div>

  <form method="POST" [formGroup]="form">

    <div class="space-y-8">

      <div>
        <app-text-input [formGroup]="form"
                        id="email"
                        [maxLength]="100"
                        type="text"
                        placeholder="Email do novo moderador/admin"
                        label="Email do novo moderador/admin"
                        [value]="form.value?.email"
                        [formError]="formErrors.get('email')"
        ></app-text-input>

      </div>

      <div class="mt-2">
        <app-text-input [formGroup]="form" type="text" id="verification"
                        [value]="form.value?.verification"
                        [hideCounter]="true"
                        placeholder="Texto de verificação"
                        label="Texto de verificação">
        </app-text-input>
        <p class="text-xs my-2">Adicione o seguinte texto no campo abaixo "<span
          class="font-bold underline">{{ verificationText }}</span>"</p>
      </div>

    </div>
    <!-- submit button -->
    <div class="my-4">
      <app-ae-button variant="primary"
        label="Transferir Ocorrências"
        [disabled]="!form.valid || form.get('verification').value !== verificationText"
        [loading]="isLoading"
        (buttonClick)="apiOnTransfer()"
        size="sm" styleClass="w-full">
      </app-ae-button>
    </div>
  </form>
</div>
